import { Signal } from "./Signal.js";
import { Slot } from "./Slot.js";

export class SlotDebounce<T extends any[]> extends Slot<T> {
    public wait: number = 0;

    private _timeout: any = null;
    private _args: any[] = null;

    public execute(args: any[]): void {
        if (this.wait <= 0) {
            this.listener.apply(this.context, args as any);
            return;
        }

        this.cancel();
        this._args = args;
        this._timeout = setTimeout(() => {
            if (this.enabled) {
                this.listener.apply(this.context, args as any);
            }
            this._args = null;
        }, this.wait);
    }

    public immediate(): void {
        this.cancel();
        if (this._args) {
            if (this.enabled) {
                this.listener.apply(this.context, this._args as any);
            }
            this._args = null;
        }
    }

    public cancel(): void {
        if (this._timeout) {
            clearTimeout(this._timeout);
        }
        this._timeout = null;
    }

    public dispose(): void {
        this.cancel();
        this._timeout = null;
        super.dispose();
    }
}